import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import {
  AportacionDIPoseedorDTO,
  AportacionDIPoseedorPayloadDTO,
  AportacionDIEstadoControllerService,
  AportacionDIPoseedorControllerService,
  OperacionGestionControllerService,
  OperacionGestionFilterDTO,
  ResiduoEnvaseControllerService,
  ResiduoEnvaseFilterDTO,
  SolicitudNimaGestoresDTO,
  SolicitudNimaPoseedorDTO,
  UserRoleEntityDTO,
} from 'api-rest';
import { Subscription, map } from 'rxjs';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';

@Component({
  selector: 'app-holders-manager-selection-dialog',
  templateUrl: './holders-manager-selection-dialog.component.html',
  styleUrls: ['./holders-manager-selection-dialog.component.scss'],
})
export class HoldersManagerSelectionDialogComponent implements OnInit {
  nimaPoseedorArray: any[] = [];
  nimaGestorArray: any[] = [];
  entityRoles: any[] = [];

  titulo : string = "Alta de aportación de DI/FS"
  isDetail:boolean = true;
  tipoAcceso: string = '';
  modelForm: FormGroup;
  subscriptions: Subscription[] = [];
  roleEntities: any[] = [];
  isGestor = false;
  isPoseedor = false;
  isGestorAndPoseedor = false;
  nimaGestorAndPoseedorArray: any[] = [];

  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private downloadService: DownloadService,
    private snackBarSrv: SnackbarService,
    private dialogRef: MatDialogRef<HoldersManagerSelectionDialogComponent>,
    private estadoAportacionesService: AportacionDIEstadoControllerService,
    private aportacionesDiService: AportacionDIPoseedorControllerService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.modelForm = this.formBuilder.group({
      fechaAceptacion: [{ value: null, disabled: false }],
      poseedor: [{ value: null, disabled: false },
          { validators: Validators.compose([Validators.required]) },
        
      ],
      gestorResiduo: [{ value: null, disabled: false }],
      gestorAndPoseedor: [{ value: null, disabled: false }],
      isPoseedor: [{ value: null, disabled: false }],
      isGestor: [{ value: null, disabled: false }],
      isGestorAndPoseedor: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
    });
    this.titulo = data?.titulo;
    this.isDetail = data?.isDetail;
    this.tipoAcceso = data?.tipoAcceso;
  }

  ngOnInit() {
    this.roleEntities = (this.authService.user as any).roleEntities;

    const rolesGestor = this.roleEntities.filter(
      (roleEntity) => roleEntity.role == 'PO-GESTOR'
    );
    const rolesPoseedor = this.roleEntities.filter(
      (roleEntity) => roleEntity.role == 'PO-POSEEDOR'
    );

    if (this.tipoAcceso === 'gestor') {
      this.isGestor = true;
      this.modelForm.get('isGestor')?.setValue(true);
      this.buscarNimaGestor();
    } else if (this.tipoAcceso === 'poseedor') {
      this.isPoseedor = true;
      this.modelForm.get('isPoseedor')?.setValue(true);
      this.buscarNimaPoseedor();
    }
    this.estadoAportacionesService
      .findAll14()
      .pipe(map((estados) => estados.find((estado) => estado.id === 1)))
      .subscribe((estado) => {
        if (estado) {
          this.modelForm.get('estado')?.setValue(estado);
        }
      });
  }

  buscarNimaGestor() {

    let tipoAportacion = '';
    if (this.tipoAcceso === 'gestor') {
      tipoAportacion = 'Gestores';
    } else if (this.tipoAcceso === 'poseedor') {
      tipoAportacion = 'Poseedores';
    }

    const filtroNimaGestor: SolicitudNimaGestoresDTO = {
      fechaAceptacion: this.modelForm.value?.fechaAceptacion,
      menuAportacionModuloPoseedores: tipoAportacion,
    };

    this.aportacionesDiService
      .nimaGestores(filtroNimaGestor)
      .subscribe((res) => {
        this.nimaGestorArray = res;
        if(!this.isDetail){
          //es para carga masiva, mostrar solo los gestores que tienen habilitada la carga masiva
          this.nimaGestorArray = this.nimaGestorArray.filter((item:any) => item.cargaMasiva == true);
        }
        this.nimaGestorAndPoseedorArray = this.nimaGestorArray.concat(this.nimaGestorAndPoseedorArray)
      });
  }

  buscarNimaPoseedor() {

    let tipoAportacione = '';
    if (this.tipoAcceso === 'gestor') {
      tipoAportacione = 'Gestores';
    } else if (this.tipoAcceso === 'poseedor') {
      tipoAportacione = 'Poseedores';
    }

    const filtroNimaPoseedor: SolicitudNimaPoseedorDTO = {
      fechaAceptacion: this.modelForm.value?.fechaAceptacion,
      menuAportacionModuloPoseedores: tipoAportacione
    };

    this.aportacionesDiService
      .nimaPoseedores(filtroNimaPoseedor)
      .subscribe((res) => {
        this.nimaPoseedorArray = res;
        if(!this.isDetail){
          //es para carga masiva, mostrar solo los poseedores que tienen habilitada la carga masiva
          this.nimaPoseedorArray = this.nimaPoseedorArray.filter((item:any) => item.cargaMasiva == true);
        }
        this.nimaGestorAndPoseedorArray = this.nimaPoseedorArray.concat(this.nimaGestorAndPoseedorArray)

      });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  seleccionar() {
    if (this.canSelectionPoseedor() || this.canSelectionGestor() ||this.canSelectionGestorAndPoseedor()) {
      this.dialogRef.close(this.modelForm.value);
    } else {
      this.snackBarSrv.showSnackBar('Debe seleccionar un Nima', 'error');
    }
  }

  showClearButton(formName: string): boolean {
    return this.modelForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.modelForm.get(formName)?.setValue(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.modelForm.controls[controlName].hasError(errorName) &&
      this.modelForm.controls[controlName].touched
    );
  }

  canSelectionPoseedor(): boolean {
    return this.modelForm.get('poseedor')?.value != null;
  }

  canSelectionGestor(): boolean {
    return this.modelForm.get('gestorResiduo')?.value != null;
  }

  canSelectionGestorAndPoseedor(): boolean {
    return this.modelForm.get('gestorAndPoseedor')?.value != null;
  }
}
